export default function getContent (activeItem, quillDesignator) {
  if (quillDesignator && activeItem) {
    if (quillDesignator.type === 'question') {
      return activeItem.question
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageContent/getContent.js